<mc-maximize-dialog-button class="mc-dialog-floating-maximize-button" [dialogRef]="dialogRef" maximizedWidth="95vw" maximizedHeight="90vh" (resized)="logTabPanel?.checkViewportSize()"></mc-maximize-dialog-button>
<button type="button" mat-icon-button class="mc-dialog-floating-close-button" tabindex="-1" (click)="closeDialog()">
  <mat-icon fontSet="project-titan" fontIcon="icon-close"></mat-icon>
</button>

<mc-loader *ngIf="loadingState.loading$ | async"></mc-loader>

<div *ngIf="loadingState.generalError$ | async as generalError" class="error-pane">
  <mc-errors-expansion-panel [generalError]="generalError" [detailedErrors]="loadingState.detailedErrors$ | async"></mc-errors-expansion-panel>
</div>

<mc-switch-board color="secondary">
  <mc-switch-board-bar class="mc-spring-board">
    <ng-container *ngIf="publication$ | async as publication">
      <div class="mc-spring-board-header">
        <mc-publication-avatar [publication]="publication" [disabled]="true"></mc-publication-avatar>
      </div>

      <div class="mc-spring-board-body">
        <ul class="mc-property-list mc-profile-switch-board-bar-section">
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Project: </span>
            <mc-project-avatar class="mc-property-value" [project]="project$ | async" [showAvatar]="false" [truncate]="true"></mc-project-avatar>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Build: </span>
            <mc-build-avatar class="mc-property-value" [build]="publication.Build" [showAvatar]="false" [truncate]="true"></mc-build-avatar>
          </li>
          <li class="mc-property-list-item-truncate">
            <span class="mc-property-name">Destination: </span>
            <mc-destination-avatar [destinationPath]="publication.DestinationFilePath" [branchName]="publication.Build?.BranchName" [project]="project$ | async" class="mc-property-value" [truncate]="true" [showAvatar]="false" [showPath]="false"></mc-destination-avatar>
          </li>
        </ul>

        <p *ngIf="publication.Process?.LastProcessAttempt?.Status !== null && publication.Process?.LastProcessAttempt?.Status !== undefined" [ngClass]="getTextColorClassForPublicationState(publication)">
          <mat-icon *ngIf="publication.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Complete" fontSet="project-titan" fontIcon="icon-checkmark" class="mc-centered-text-icon"></mat-icon>
          <mat-icon *ngIf="publication.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Canceled" fontSet="project-titan" fontIcon="icon-stoppublicationcommand" class="mc-centered-text-icon"></mat-icon>
          <mat-icon *ngIf="publication.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Failed || publication.Process?.LastProcessAttempt?.Status === ProcessAttemptStatus.Aborted" fontSet="project-titan" fontIcon="icon-close" class="mc-centered-text-icon"></mat-icon>
          &nbsp;{{ getStatusDisplayText(publication) }}
        </p>
      </div>

      <mat-nav-list class="mc-spring-board-footer mc-list-text-size-normal mc-list-text-weight-normal mc-list-bg-dark mc-list-compact">
        <ng-container *ngIf="showCancelPublicationTab$ | async">
          <a href="#" mat-list-item mcPreventDefault="click" (click)="onCancelPublicationClicked(publication)">
            <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-stoppublicationcommand" color="warn-muted"></mat-icon> Cancel Publication
          </a>
          <mat-divider></mat-divider>
        </ng-container>
        <a href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="publicationProfileTab === PublicationProfileTab.Overview" (click)="publicationProfileTab = PublicationProfileTab.Overview">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-overview" color="primary"></mat-icon> Overview
        </a>
        <a *ngIf="showLogTab$ | async" href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="publicationProfileTab === PublicationProfileTab.Log" (click)="publicationProfileTab = PublicationProfileTab.Log">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-openbuildlogcommand" color="primary"></mat-icon> Log
        </a>
        <a *ngIf="showDeleteTab$ | async" href="#" mat-list-item mcPreventDefault="click" [class.mc-list-item-selected]="publicationProfileTab === PublicationProfileTab.Delete" (click)="publicationProfileTab = PublicationProfileTab.Delete">
          <mat-icon matListItemIcon fontSet="project-titan" fontIcon="icon-trash" color="primary"></mat-icon> Delete Publication
        </a>
      </mat-nav-list>
    </ng-container>
  </mc-switch-board-bar>

  <mc-switch-board-content [ngSwitch]="publicationProfileTab" class="mc-spring-board">
    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="PublicationProfileTab.Overview" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Overview">
        <mc-publication-overview [publication]="publication$ | async"></mc-publication-overview>
      </mat-tab>
    </mat-tab-group>

    <ng-container *ngSwitchCase="PublicationProfileTab.Log">
      <mc-log-tab-panel *ngIf="publication$ | async as publication"
        [streamUrl]="logStreamUrl"
        [sourceLinkResolver]="resolvePublicationSourceLink"
        [emptyLabelOverride]="emptyLabelOverride"
        [loading]="logPrepareLoadingState.loading$ | async"
        [generalError]="logPrepareLoadingState.generalError$ | async"
        [detailedErrors]="logPrepareLoadingState.detailedErrors$ | async"
        [canDownloadLog]="canDownloadLog$ | async"
        [logUnavailable]="logUnavailable$ | async"
        gridId="publication-logs-dialog-grid"
        settingsKey="publication-logs-grid:type-filter"
        emptySubject="this publication"
        (downloadLog)="onDownloadLogClicked(publication)">
      </mc-log-tab-panel>
    </ng-container>

    <mat-tab-group mat-stretch-tabs="false" *ngSwitchCase="PublicationProfileTab.Delete" class="mc-spring-board-body mc-arrow-tabs mc-arrow-tabs-border" color="secondary-invert">
      <mat-tab label="Delete Publication">
        <mc-publication-deletion-form [publication]="publication$ | async" (cancel)="onCancel()" (deleted)="onSaved(PublicationProfileForm.Delete)"></mc-publication-deletion-form>
      </mat-tab>
    </mat-tab-group>
  </mc-switch-board-content>
</mc-switch-board>